import { render, staticRenderFns } from "./df-section-products-filter.vue?vue&type=template&id=92664ea8"
import script from "./df-section-products-filter.ts?vue&type=script&lang=js&external"
export * from "./df-section-products-filter.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports